// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"u5-z"};